// Feature-detected: most desktop browsers have no Vibration API and some
// mobile browsers restrict it to user-gesture contexts — both are silent
// no-ops here, never an error.
export function haptic(ms = 15) {
  if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
    navigator.vibrate(ms);
  }
}
